import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Input, FormText } from "reactstrap";
import "../App.css";
import Users from "./users";
import Convos from "./convos";
import Socket from "../utils/socket";

const UserForm = () => {
  const [inputText, setInputText] = useState("");
  const [convos, set] = useState([]);

  const [username, setUsername] = useState("");

  useEffect(() => {
    Socket.emit("NEW_USER");

    Socket.on("GET_CURRENT_USER", user => {
      setUsername(user.username);
    });
    Socket.on("RECEIVE_BROADCAST", e => {
      set(convos => {
        const replica = [...convos];
        replica.push(e);
        return replica;
        console.log(replica);
      });
    });

    Socket.on("HAS_ERROR", e => console.log(e));
  }, []);

  const sendMsg = e => {
    e.preventDefault();
    console.log("clicked/sent");
  };
  const InputValid = () => {
    if (!inputText.length) {
      return { invalid: true };
    }

    if (inputText.length >= 40) {
      return { invalid: true };
    }
    if (!(!inputText.length && inputText.length >= 40)) {
      return { valid: true };
    }
  };
  const formtxt = () => {
    if (!inputText.length) {
      return null;
    }

    if (inputText.length >= 40) {
      return <FormText>Error</FormText>;
    }
  };
  const msgSubmit = e => {
    e.preventDefault();
    const replica = [...convos];

    const obj = {
      username,
      message: `${inputText}`,
      timestamp: Date.now()
    };
    replica.push(obj);
    setInputText("");
    Socket.emit("BROADCAST_MESSAGE", obj);
  };

  function addObserverIfNodeAvailable() {
    var someElement = document.querySelector(".autoscroll");
    if (!someElement) {
      //The node we need does not exist yet.
      //Wait 500ms and try again
      window.setTimeout(addObserverIfNodeAvailable, 500);
      return;
    }
    function scrollToBottom() {
      someElement.scrollTop = someElement.scrollHeight;
    }
    var config = { childList: true };
    var observer = new MutationObserver(scrollToBottom);
    // Tell it to look for new children that will change the height.
    observer.observe(someElement, config);
  }

  addObserverIfNodeAvailable();

  return (
    <div className="full" style={{ height: "80vh" }}>
      {/* users div */}
      <Users convos={convos} />
      <div style={{ height: "80vh", width: "70vw" }}>
        {/* display div */}
        <div
          className="autoscroll"
          style={{
            height: "90%",
            backgroundColor: "rgb(255,110,50)",
            overflowY: "scroll"
          }}
        >
          <Convos convos={convos} />
        </div>

        <Form onSubmit={msgSubmit}>
          <FormGroup className="d-flex flex-wrap">
            <Input
              {...InputValid()}
              style={{ width: "88%", height: "60px" }}
              type="text"
              id="exampleText"
              placeholder="Type message..."
              value={inputText}
              onChange={e => {
                setInputText(e.target.value);
              }}
            />

            <Button
              disabled={!inputText || inputText.length >= 40}
              type="submit"
              color="success"
              size="lg"
            >
              Send
            </Button>
            {formtxt()}
          </FormGroup>
        </Form>
      </div>
    </div>
  );
};
export default UserForm;
